module.exports = __webpack_public_path__ + "static/media/blog.ecaee1aa.svg";